export default {
  EMPTY_FEED: 'There is no activity to be displayed yet.',
  FEED_SLIDER_GENERIC_ASSIGNED_TITLE: 'Assigned',
  FEED_SLIDER_GENERIC_NOTES_TITLE: 'Notes',
  FEED_SLIDER_DETAILS_TITLE: 'Details',
  FEED_INTERACTION_LABEL: 'Interaction',
  FEED_ANNOUNCEMENT_LABEL: 'Announcement',
  FEED_CONTRIBUTION_LABEL: 'Contribution',
  FEED_TREND_LABEL: 'Trend',
  FEED_CAMPAIGN_LABEL: 'Campaign',
  DELETE_FEED_ENTITY_SUCCESS_MESSAGE: 'The {entity} was succesfully removed',
  DELETE_FEED_ENTITY_ERROR_MESSAGE: "Couldn't remove the {entity}",
  FEED_ENTITY_DELETED: 'This {entity} was deleted.',
  FEED_ENTITY_DELETED_INTEGRATION:
    'This {entity} was removed or refunded in {integration}.',
};
